import { ethers } from 'ethers';

const USDC_DECIMALS_FORMAT = 6;
const CDK_DECIMALS = 6;
const USDC_TO_TOKEN_PRICE_DECIMALS = 3; // to define 0.25 USDC for 1 CDK you must send 250 as tokenPrice to the contract
const USDC_DECIMALS_PARSE = 6;

// -- send data to web3 -- do use send for getting from faucet
export const parseUsdc = (amount: string | number): bigint => {
    return ethers.parseUnits(amount.toString(), 18); // do not parse to 6 decimals, we want to keep 1 decimal
}

export const parseCdk = (amount: string | number): bigint => {
    return ethers.parseUnits(amount.toString(), CDK_DECIMALS);
}

export const parseUsdcToTokenPrice = (amount: string | number): bigint => {
    return ethers.parseUnits(amount.toString(), USDC_TO_TOKEN_PRICE_DECIMALS);
}

// -- retrieve data from web3
export const formatCdk = (amount: any): number => {
    return Number(ethers.formatUnits(toBigInt(amount), CDK_DECIMALS));
}

export const formatUsdc = (amount: any): number => {
    return Number(ethers.formatUnits(toBigInt(amount), USDC_DECIMALS_FORMAT));
}

export const formatUsdcToTokenPrice = (amount: bigint): number => {
    return Number(ethers.formatUnits(amount, USDC_TO_TOKEN_PRICE_DECIMALS));
}

const toBigInt = (amount: any): bigint => {
    if (typeof amount === 'string') {
        return BigInt(amount);
    } else if (typeof amount === 'number') {
        return BigInt(Math.floor(amount).toString());
    } else if (typeof amount === 'bigint') {
        return amount;
    }
    throw new Error('Invalid amount type');
}

// web3/utils.ts - New utility file for web3 helper functions

/**
 * Checks if the user is on a mobile device
 * @returns {boolean} True if the user is on a mobile device
 */
export const isMobile = (): boolean => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  
  // Check for touch devices as an additional indicator
  const hasTouchScreen = (): boolean => {
    return ('ontouchstart' in window) || 
           (navigator.maxTouchPoints > 0) || 
           ((navigator as any).msMaxTouchPoints > 0);
  };
  
  // Standard mobile user agent check
  const mobileCheck = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  
  // Return true if either check passes
  return mobileCheck || hasTouchScreen();
};

/**
 * Checks if the user is on an Android device
 * @returns {boolean} True if the user is on an Android device
 */
export const isAndroid = (): boolean => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  return /Android/i.test(userAgent);
};

/**
 * Checks if the user is on an iOS device
 * @returns {boolean} True if the user is on an iOS device
 */
export const isIOS = (): boolean => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  return /iPhone|iPad|iPod/i.test(userAgent);
};

/**
 * Checks if the user is using an in-app browser
 * @returns {boolean} True if the user is using an in-app browser
 */
export const isInAppBrowser = (): boolean => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  return (
    /Instagram/.test(userAgent) ||
    /FBAV/.test(userAgent) || // Facebook
    /Line/.test(userAgent) ||
    /wv/.test(userAgent) || // Android WebView
    /FBAN/.test(userAgent) || // Facebook app
    /Twitter/.test(userAgent) ||
    /TikTok/.test(userAgent)
  );
};